import CryptoJS from 'crypto-js';

export function getFilter(key, value, target) {
  const filter = target.filter(el => el[key] === value);
  return filter.length > 0 ? filter[0] : {};
}

export function locatTo(posY) {
  document.body.scrollTop = document.documentElement.scrollTop = posY;

  // 存在滚动不到的情况，所有做兼容处理
  setTimeout(() => {
    document.body.scrollTop = document.documentElement.scrollTop = posY;
  });
}

export function isInH5() {
  const userAgentInfo = navigator.userAgent;
  const Agents = new Array(
    'Android',
    'iPhone',
    'SymbianOS',
    'Windows Phone',
    'iPad',
    'iPod',
  );
  let flag = false;

  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = true;
      break;
    }
  }

  return flag;
}

// 无线设备判断
export function isWirelessDevice() {
  // eslint-disable-next-line
  return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
}

export function setPageScale(scale) {
  document.getElementsByName(
    'viewport',
  )[0].content = `width=device-width,initial-scale=${scale}`;
}

/**
 * AES加密
 */
export function encryptByAES(message, key) {
  const keyHex = CryptoJS.enc.Utf8.parse(key);
  // const srcs = CryptoJS.enc.Utf8.parse(message);
  const encrypted = CryptoJS.AES.encrypt(message, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encrypted.toString();
}

/**
 * AES解密
 */
export function decryptByAES(ciphertext, key) {
  const keyHex = CryptoJS.enc.Utf8.parse(key);
  const decrypted = CryptoJS.AES.decrypt(
    {
      ciphertext: CryptoJS.enc.Base64.parse(ciphertext),
    },
    keyHex,
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    },
  );

  return decrypted.toString(CryptoJS.enc.Utf8);
}

/**
 * 手机号码或者电话号校验（电话号输入-)
 */
export function checkPhoneNumber(value) {
  let mobile = /^[1][34578]\d{9}$/;
  let tel = /^\d{3,4}-\d{7,9}$/;
  if (tel.test(value) || mobile.test(value)) {
    return true;
  }
  return false;
}
